import React, { useEffect, useState } from "react";
import "./PhotographerProfileForm.css";
import { useLocation, useParams } from "react-router-dom";
import { GetPhotographerProfileAPI, getServicesAPI, UpdatePhotographerProfileAPI } from "../../../../utils/APIs/photographersApis";
import Loader from "../../../../Loader/Loader";
import { toast } from "react-toastify";

const PhotographerProfileForm = () => {
  const { state } = useLocation();
  const { photographerId } = useParams();
  const [servicesList, setServicesList] = useState([]);
  const [loadingServices, setLoadingServices] = useState(false);
  const [loadingProfile, setLoadingProfile] = useState(false);
  /* ===== Form State ===== */
  const [formData, setFormData] = useState({
    fullName: state?.photographer?.name || "",
    displayName: state?.photographer?.displayName || "",
    email: state?.photographer?.email || "",
    phone: state?.photographer?.phone || "",
    photographerType: "",
    experience: "",
    location: "",
    travel: "",
    languages: "",
    hasStudio: "no",
    studioName: "",
    about: "",
    services: [],
    availabilityStatus: "",
    workingDays: "",
    timeSlots: "",
    maxBookings: "",
    startingPrice: "",
    customQuote: false,
    accountHolder: "",
    bankName: "",
    accountNumber: "",
    confirmAccountNumber: "",
    ifsc: "",
    accountType: "",
    gstRegistered: "no",
    gstNumber: "",
  });

  const [errors, setErrors] = useState({});

  const photographer = state?.photographer;



  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoadingServices(true);
        const res = await getServicesAPI();
        console.log("SERVICES API", res?.data?.data);

        // adjust depending on backend response structure
        if (res?.data?.success) {
          setServicesList(res?.data?.data || []);
        }

      } catch (error) {
        console.error("Failed to fetch services", error);
      } finally {
        setLoadingServices(false);
      }
    };

    fetchServices();
  }, []);

  useEffect(() => {
    const fetchPhotographerProfile = async () => {
      try {
        setLoadingProfile(true);

        const res = await GetPhotographerProfileAPI(photographerId);
        console.log("RESPONSE PROFILE..", res?.data?.photographer)
        if (res?.data?.success || res?.status === 200) {
          const data = res?.data?.photographer;

          console.log("RESPONSE PROFILE..", data)

          setFormData({
            fullName: data?.basicInfo?.fullName || "",
            displayName: data?.basicInfo?.displayName || "",
            email: data?.basicInfo?.email || "",
            phone: data?.basicInfo?.phone || "",

            photographerType: data?.professionalDetails?.photographerType || "",
            experience: data?.professionalDetails?.yearsOfExperience || "",
            location: data?.professionalDetails?.primaryLocation || "",
            travel: data?.professionalDetails?.willingToTravel ? "yes" : "no",
            languages: data?.professionalDetails?.languagesSpoken?.join(", ") || "",
            hasStudio: data?.hasStudio ? "yes" : "no",
            studioName: data?.studioName || "",
            about: data?.aboutYou || "",

            services: [
              ...Object.entries(data?.servicesAndStyles?.services || {})
                .filter(([_, value]) => value)
                .map(([key]) => key),

              ...Object.entries(data?.servicesAndStyles?.styles || {})
                .filter(([_, value]) => value)
                .map(([key]) => key)
            ],

            availabilityStatus: data?.availability?.status || "",
            workingDays: data?.availability?.workingDays?.join(", ") || "",
            timeSlots: data?.availability?.preferredTimeSlots?.join(", ") || "",
            maxBookings: data?.availability?.maxBookingsPerDay || "",

            startingPrice: data?.pricing?.startingPrice || "",
            customQuote: data?.pricing?.customQuotesEnabled || false,

            accountHolder: data?.bank_account_holder || "",
            bankName: data?.bank_name || "",
            accountNumber: data?.bank_account_number || "",
            confirmAccountNumber: data?.bank_account_number || "",
            ifsc: data?.bank_ifsc || "",
            accountType: data?.account_type || "",
            gstRegistered: data?.gstRegistered ? "yes" : "no",
            gstNumber: data?.gstNumber || "",
          });


          setLevel(data?.professionalDetails?.expertiseLevel || "ELITE");
        }

      } catch (error) {
        toast.error("Failed to fetch photographer profile");
        console.error(error);
      } finally {
        setLoadingProfile(false);
      }
    };

    if (photographerId) {
      fetchPhotographerProfile();
    }
  }, [photographerId]);


  console.log("PHOTOGRAPHER PROFILE DATA", photographer)
  console.log("PHOTOGRAPHER ID", photographerId)
  console.log("Photographer formData", formData)




  /* ===== Level Tracker ===== */
  const [level, setLevel] = useState("ELITE");
  const isInitio = level === "INITIO";
  const isElite = level === "ELITE";
  const isPro = level === "PRO";
  const isStandard = level === "STANDARD";
  const isPremium = level === "PREMIUM";

  // Watch for photographer type changes to reset default level
  useEffect(() => {
    const pType = formData.photographerType?.trim()?.toLowerCase();

    if (pType === "editor") {
      if (!["STANDARD", "PREMIUM"].includes(level)) {
        setLevel("STANDARD");
      }
    } else if (["photographer", "videographer", "lighting setup"].includes(pType)) {
      if (!["INITIO", "ELITE", "PRO"].includes(level)) {
        setLevel("INITIO");
      }
    }
  }, [formData.photographerType, level]);



  /* ===== Handlers ===== */
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    
    // Clear error for this field
    if (errors[name]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  // const handleServicesChange = (e) => {
  //   const values = Array.from(
  //     e.target.selectedOptions,
  //     (option) => option.value
  //   );
  //   setFormData((prev) => ({
  //     ...prev,
  //     services: values,
  //   }));
  // };

  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   const payload = {
  //     ...formData,
  //     level,
  //   };

  //   console.log("FINAL SUBMIT DATA 👉", payload);
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const newErrors = {};
      let firstError = "";

      // Basic Info
      if (!formData.fullName.trim()) {
        newErrors.fullName = "Full Name is required";
        if (!firstError) firstError = "Full Name is required";
      }
      if (!formData.displayName.trim()) {
        newErrors.displayName = "Display Name is required";
        if (!firstError) firstError = "Display Name is required";
      }
      if (!formData.email.trim()) {
        newErrors.email = "Email is required";
        if (!firstError) firstError = "Email is required";
      } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        newErrors.email = "Invalid email format";
        if (!firstError) firstError = "Invalid email format";
      }
      if (!formData.phone.trim()) {
        newErrors.phone = "Phone number is required";
        if (!firstError) firstError = "Phone number is required";
      }

      // Professional Details
      if (!formData.photographerType) {
        newErrors.photographerType = "Photographer Type is required";
        if (!firstError) firstError = "Photographer Type is required";
      }
      if (formData.experience === "") {
        newErrors.experience = "Experience is required";
        if (!firstError) firstError = "Experience is required";
      }
      if (!formData.location.trim()) {
        newErrors.location = "Primary Location is required";
        if (!firstError) firstError = "Primary Location is required";
      }
      if (!formData.travel) {
        newErrors.travel = "Travel preference is required";
        if (!firstError) firstError = "Travel preference is required";
      }

      // Availability
      if (!formData.availabilityStatus) {
        newErrors.availabilityStatus = "Availability Status is required";
        if (!firstError) firstError = "Availability Status is required";
      }

      // Bank Details
      if (!formData.accountHolder.trim()) {
        newErrors.accountHolder = "Account holder name is required";
        if (!firstError) firstError = "Account holder name is required";
      }
      if (!formData.bankName.trim()) {
        newErrors.bankName = "Bank name is required";
        if (!firstError) firstError = "Bank name is required";
      }
      if (!formData.accountNumber.trim()) {
        newErrors.accountNumber = "Account number is required";
        if (!firstError) firstError = "Account number is required";
      }
      if (!formData.confirmAccountNumber.trim()) {
        newErrors.confirmAccountNumber = "Please confirm your account number";
        if (!firstError) firstError = "Please confirm your account number";
      }
      if (!formData.ifsc.trim()) {
        newErrors.ifsc = "IFSC code is required";
        if (!firstError) firstError = "IFSC code is required";
      }
      if (!formData.accountType) {
        newErrors.accountType = "Account type is required";
        if (!firstError) firstError = "Account type is required";
      }

      if (formData.gstRegistered === "yes" && !formData.gstNumber?.trim()) {
        newErrors.gstNumber = "GST Number is required when GST Registered is Yes";
        if (!firstError) firstError = "GST Number is required when GST Registered is Yes";
      }

      // Match check
      if (formData.accountNumber !== formData.confirmAccountNumber) {
        newErrors.confirmAccountNumber = "Account numbers do not match";
        if (!firstError) firstError = "Account numbers do not match";
      }

      // Regex checks
      const accountRegex = /^[0-9]{9,18}$/;
      const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;

      if (formData.accountNumber && !accountRegex.test(formData.accountNumber)) {
        newErrors.accountNumber = "Invalid account number (should be 9-18 digits)";
        if (!firstError) firstError = "Invalid account number (should be 9-18 digits)";
      }

      if (formData.ifsc && !ifscRegex.test(formData.ifsc)) {
        newErrors.ifsc = "Invalid IFSC Code (e.g. SBIN0012345)";
        if (!firstError) firstError = "Invalid IFSC Code (e.g. SBIN0012345)";
      }

      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        toast.error(firstError);
        return;
      }

      setErrors({});

      const payload = {
        basicInfo: {
          fullName: formData.fullName,
          displayName: formData.displayName,
          email: formData.email,
          phone: formData.phone,
        },

        professionalDetails: {
          photographerType: formData.photographerType,
          expertiseLevel: level,
          yearsOfExperience: formData.experience,
          primaryLocation: formData.location,
          willingToTravel: formData.travel === "yes",
          languagesSpoken: formData.languages ? formData.languages.split(",").map((l) => l.trim()) : [],
        },

        aboutYou: formData.about,

        servicesAndStyles: {
          services: servicesList.reduce((acc, service) => {
            acc[service.key] =
              formData.services.includes(service.key);
            return acc;
          }, {}),

          styles: {
            documentary: formData.services.includes("Documentary"),
            candid: formData.services.includes("Candid"),
            editorial: formData.services.includes("Editorial"),
          },
        },

        availability: {
          status: formData.availabilityStatus,
          workingDays: formData.workingDays
            ? formData.workingDays.split(",").map((d) => d.trim())
            : [],
          preferredTimeSlots: formData.timeSlots
            ? formData.timeSlots.split(",").map((t) => t.trim())
            : [],
          maxBookingsPerDay: Number(formData.maxBookings),
        },

        pricing: {
          startingPrice: Number(formData.startingPrice),
          currency: "USD", // change if needed
          customQuotesEnabled: formData.customQuote,
        },

        bank_account_holder: formData.accountHolder,
        bank_name: formData.bankName,
        bank_account_number: formData.accountNumber,
        bank_ifsc: formData.ifsc,
        account_type: formData.accountType,
        gstRegistered: formData.gstRegistered === "yes",
        gstNumber: formData.gstRegistered === "yes" ? formData.gstNumber : "",
        hasStudio: formData.hasStudio === "yes",
        studioName: formData.hasStudio === "yes" ? formData.studioName : "",

        photographyAccessories: [], // add later if needed
        calendar_availability: "{}",
      };

      console.log("FINAL PAYLOAD 👉", payload);


      setLoadingProfile(true)

      const res = await UpdatePhotographerProfileAPI(
        photographerId,
        payload
      );

      if (res?.data?.success) {
        toast.success("Profile updated successfully");
      } else {
        toast.error(res?.data?.message || "Update failed");
      }

    } catch (error) {
      setLoadingProfile(false)
      console.error(error);
      const errorMsg = error.response?.data?.message || error.response?.data?.error || "Something went wrong";
      toast.error(errorMsg);
    }
    finally {
      setLoadingProfile(false)
    }
  };


  if (loadingServices || loadingProfile) {
    return <Loader />
  }

  return (
    <div className="profile-form-wrapper">
      <h2 className="form-title">Photographer Profile</h2>

      <form className="profile-form" onSubmit={handleSubmit}>
        {/* ===== Basic Info ===== */}
        <div className="form-section">
          <h3>Basic Information</h3>

          <div className="form-grid">
            <div className="input-group">
              <label>Full Name</label>
              <input
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                placeholder="John Doe"
                className={errors.fullName ? "error-input" : ""}
              />
              {errors.fullName && <span className="error-msg">{errors.fullName}</span>}
            </div>

            <div className="input-group">
              <label>Display Name </label>
              <input
                name="displayName"
                value={formData.displayName}
                onChange={handleChange}
                placeholder="Photography Brand Name"
                className={errors.displayName ? "error-input" : ""}
              />
              {errors.displayName && <span className="error-msg">{errors.displayName}</span>}
            </div>

            <div className="input-group">
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={errors.email ? "error-input" : ""}
              />
              {errors.email && <span className="error-msg">{errors.email}</span>}
            </div>

            <div className="input-group">
              <label>Phone Number</label>
              <input
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className={errors.phone ? "error-input" : ""}
              />
              {errors.phone && <span className="error-msg">{errors.phone}</span>}
            </div>
          </div>
        </div>

        {/* ===== Professional Details ===== */}
        <div className="form-section">
          <h3>Professional Details</h3>

          <div className="form-grid">
            <div className="input-group">
              <label>Photographer Type</label>
              <select
                name="photographerType"
                value={formData.photographerType}
                onChange={handleChange}
                className={errors.photographerType ? "error-input" : ""}
              >
                <option value="">Select Type</option>
                <option value="Photographer">Photographer</option>
                <option value="Videographer">Videographer</option>
                <option value="Editor">Editor</option>
                <option value="Lighting Setup">Lighting Setup</option>
              </select>
              {errors.photographerType && <span className="error-msg">{errors.photographerType}</span>}
            </div>

            <div className="input-group">
              <label>Years of Experience</label>
              <input
                type="number"
                name="experience"
                value={formData.experience}
                onChange={handleChange}
                min={0}
                className={errors.experience ? "error-input" : ""}
              />
              {errors.experience && <span className="error-msg">{errors.experience}</span>}
            </div>

            <div className="input-group">
              <label>Primary Location</label>
              <input
                name="location"
                value={formData.location}
                onChange={handleChange}
                className={errors.location ? "error-input" : ""}
              />
              {errors.location && <span className="error-msg">{errors.location}</span>}
            </div>

            <div className="input-group">
              <label>Willing to Travel</label>
              <select
                name="travel"
                value={formData.travel}
                onChange={handleChange}
                className={errors.travel ? "error-input" : ""}
              >
                <option value="">Select</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
              {errors.travel && <span className="error-msg">{errors.travel}</span>}
            </div>

            <div>
              <label>Languages Spoken</label>
              <input
                name="languages"
                value={formData.languages}
                onChange={handleChange}
              />
            </div>

            <div className="input-group">
              <label>Studio</label>
              <select
                name="hasStudio"
                value={formData.hasStudio}
                onChange={handleChange}
              >
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </div>

            {formData.hasStudio === "yes" && (
              <div className="input-group">
                <label>Studio Name</label>
                <input
                  name="studioName"
                  value={formData.studioName}
                  onChange={handleChange}
                />
              </div>
            )}
          </div>

          <label>About You</label>
          <textarea
            name="about"
            rows="4"
            value={formData.about}
            onChange={handleChange}
          />

          {/* ===== Level Tracker ===== */}
          <div className="level-tracker">
            {formData.photographerType?.trim()?.toLowerCase() === "editor" ? (
              <>
                <div
                  className={`tracker-step ${isStandard || isPremium ? "active" : ""}`}
                  onClick={() => setLevel("STANDARD")}
                >
                  <span className="dot" />
                  <p>STANDARD</p>
                </div>

                <div className={`tracker-line ${isPremium ? "active-line" : ""}`} />

                <div
                  className={`tracker-step ${isPremium ? "active" : ""}`}
                  onClick={() => setLevel("PREMIUM")}
                >
                  <span className="dot" />
                  <p>PREMIUM</p>
                </div>
              </>
            ) : (
              <>
                <div
                  className={`tracker-step ${isInitio || isElite || isPro ? "active" : ""}`}
                  onClick={() => setLevel("INITIO")}
                >
                  <span className="dot" />
                  <p>INITIO</p>
                </div>

                <div className={`tracker-line ${isElite || isPro ? "active-line" : ""}`} />

                <div
                  className={`tracker-step ${isElite || isPro ? "active" : ""}`}
                  onClick={() => setLevel("ELITE")}
                >
                  <span className="dot" />
                  <p>ELITE</p>
                </div>

                <div className={`tracker-line ${isPro ? "active-line" : ""}`} />

                <div
                  className={`tracker-step ${isPro ? "active" : ""}`}
                  onClick={() => setLevel("PRO")}
                >
                  <span className="dot" />
                  <p>PRO</p>
                </div>
              </>
            )}
          </div>
        </div>

        {/* ===== Services ===== */}

        <div className="form-section">
          <h3>Services & Style</h3>

          {loadingServices ? (
            <p>Loading services...</p>
          ) : (
            <div className="services-grid">
              {servicesList.map((service) => (
                <label key={service._id} className="service-pill">
                  <input
                    type="checkbox"
                    value={service.key}
                    checked={formData.services.includes(service.key)}
                    // onChange={(e) => {
                    //   const value = e.target.value;
                    //   setFormData((prev) => ({
                    //     ...prev,
                    //     services: prev.services.includes(value)
                    //       ? prev.services.filter((s) => s !== value)
                    //       : [...prev.services, value],
                    //   }));
                    // }}


                    onChange={(e) => {
                      const value = e.target.value;

                      console.log("Clicked value:", value);
                      console.log("Before update:", formData.services);
                      console.log(
                        "Already included?",
                        formData.services.includes(value)
                      );

                      setFormData((prev) => {
                        console.log("Previous services:", prev.services);
                        console.log("Clicked value:", value);

                        const alreadyIncluded = prev.services.includes(value);
                        console.log("Already included?", alreadyIncluded);

                        let updatedServices;

                        if (alreadyIncluded) {
                          updatedServices = prev.services.filter((s) => s !== value);
                          console.log("Removing value...");
                        } else {
                          updatedServices = [...prev.services, value];
                          console.log("Adding value...");
                        }

                        console.log("Updated services:", updatedServices);

                        return {
                          ...prev,
                          services: updatedServices,
                        };
                      });

                    }}

                  />
                  <span>{service.serviceName}</span>
                </label>
              ))}
            </div>
          )}
        </div>




        {/* ===== Availability ===== */}
        <div className="form-section">
          <h3>Availability</h3>

          <div className="form-grid">
            <div className="input-group">
              <label>Status</label>
              <select
                name="availabilityStatus"
                value={formData.availabilityStatus}
                onChange={handleChange}
                className={errors.availabilityStatus ? "error-input" : ""}
              >
                <option value="">Select</option>
                <option value="available">Available</option>
                <option value="busy">Busy</option>
              </select>
              {errors.availabilityStatus && <span className="error-msg">{errors.availabilityStatus}</span>}
            </div>

            <div>
              <label>Working Days</label>
              <input
                name="workingDays"
                value={formData.workingDays}
                onChange={handleChange}
              />
            </div>

            <div>
              <label>Preferred Time Slots</label>
              <input
                name="timeSlots"
                value={formData.timeSlots}
                onChange={handleChange}
              />
            </div>

            <div>
              <label>Max Bookings / Day</label>
              <input
                type="number"
                name="maxBookings"
                value={formData.maxBookings}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Pricing</h3>

          <div className="form-grid">
            <div>
              <label>Starting Price</label>
              <input
                type="number"
                name="startingPrice"
                value={formData.startingPrice}
                onChange={handleChange}
              />
            </div>

            <div className="toggle-switch">
              <span>Custom Quote Available</span>

              <label className="switch">
                <input
                  type="checkbox"
                  name="customQuote"
                  checked={formData.customQuote}
                  onChange={handleChange}
                />
                <span className="slider" />
              </label>
            </div>

          </div>
        </div>

        {/* ===== Bank Details ===== */}
        <div className="form-section">
          <h3>Bank Details</h3>

          <div className="form-grid">
            <div className="input-group">
              <input
                name="accountHolder"
                placeholder="Account Holder Name"
                value={formData.accountHolder}
                onChange={handleChange}
                className={errors.accountHolder ? "error-input" : ""}
              />
              {errors.accountHolder && <span className="error-msg">{errors.accountHolder}</span>}
            </div>

            <div className="input-group">
              <input
                name="bankName"
                placeholder="Bank Name"
                value={formData.bankName}
                onChange={handleChange}
                className={errors.bankName ? "error-input" : ""}
              />
              {errors.bankName && <span className="error-msg">{errors.bankName}</span>}
            </div>

            <div className="input-group">
              <input
                name="accountNumber"
                placeholder="Account Number"
                value={formData.accountNumber}
                onChange={handleChange}
                className={errors.accountNumber ? "error-input" : ""}
              />
              {errors.accountNumber && <span className="error-msg">{errors.accountNumber}</span>}
            </div>

            <div className="input-group">
              <input
                name="confirmAccountNumber"
                placeholder="Confirm Account Number"
                value={formData.confirmAccountNumber}
                onChange={handleChange}
                className={errors.confirmAccountNumber ? "error-input" : ""}
              />
              {errors.confirmAccountNumber && <span className="error-msg">{errors.confirmAccountNumber}</span>}
            </div>

            <div className="input-group">
              <input
                name="ifsc"
                placeholder="IFSC Code"
                value={formData.ifsc}
                onChange={handleChange}
                className={errors.ifsc ? "error-input" : ""}
              />
              {errors.ifsc && <span className="error-msg">{errors.ifsc}</span>}
            </div>

            {/* <div className="radio-group">
              <label>Account Type</label>
              <label>
                <input
                  type="radio"
                  name="accountType"
                  value="saving"
                  checked={formData.accountType === "saving"}
                  onChange={handleChange}
                />
                Saving
              </label>

              <label>
                <input
                  type="radio"
                  name="accountType"
                  value="current"
                  checked={formData.accountType === "current"}
                  onChange={handleChange}
                />
                Current
              </label>
            </div> */}
            <div className="radio-group">
              <label className="group-label">Account Type</label>
              <div className="radio-options">
                <label className="radio-card">
                  <input
                    type="radio"
                    name="accountType"
                    value="Savings"
                    checked={formData.accountType === "Savings"}
                    onChange={handleChange}
                  />
                  <span>Saving</span>
                </label>

                <label className="radio-card">
                  <input
                    type="radio"
                    name="accountType"
                    value="Current"
                    checked={formData.accountType === "Current"}
                    onChange={handleChange}
                  />
                  <span>Current</span>
                </label>
              </div>
              {errors.accountType && <span className="error-msg">{errors.accountType}</span>}
            </div>

            <div className="input-group" style={{ gridColumn: "span 2", marginTop: "10px" }}>
              <label>GST Registered *</label>
              <select
                name="gstRegistered"
                value={formData.gstRegistered}
                onChange={handleChange}
                className={errors.gstRegistered ? "error-input" : ""}
              >
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </div>

            {formData.gstRegistered === "yes" && (
              <div className="input-group" style={{ gridColumn: "span 2", marginTop: "10px" }}>
                <label>GST Number *</label>
                <input
                  name="gstNumber"
                  value={formData.gstNumber}
                  onChange={handleChange}
                  placeholder="Enter GST Number"
                  className={errors.gstNumber ? "error-input" : ""}
                />
                {errors.gstNumber && <span className="error-msg">{errors.gstNumber}</span>}
              </div>
            )}

          </div>
        </div>

        <button type="submit" className="submit-btn">
          Update Profile
        </button>
      </form>
    </div>
  );
};

export default PhotographerProfileForm;
